const ModalTasksTable = ({items, itemsShow, checked, setChecked, multiple = true}) => {

    const handleCheckbox = (e) => {
        let {name, value} = e.target;
        let checkbox, idx;
        checkbox = e.target;
        idx = parseInt(value);

        setterCheckbox(checkbox, idx);
    };
    const handleRow = (e) => {
        let tr = e.target.closest("tr");
        let checkbox, idx;
        checkbox = tr.querySelector("input[type=checkbox]");
        checkbox.checked = !checkbox.checked;
        idx = parseInt(tr.getAttribute("data-idx"));
        setterCheckbox(checkbox, idx);
    };

    const setterCheckbox = (checkbox, idx) => {
        let item_ = items.current.showed[idx];
        if (checkbox.checked) {
            if (!multiple) {
                items.current.checked = [item_.id];
            } else {
                items.current.checked.push(item_.id);
            }
        } else {
            items.current.checked = items.current.checked.filter(id => id !== item_.id);
        }
        setChecked([...items.current.checked])
    }


    return (
        <table className="table table-striped">
            <thead>
            <tr>
                <th style={{width: "30px"}}></th>
                <th>Nombre</th>
            </tr>
            </thead>
            <tbody>
            {
                itemsShow.map((item, index) => (
                    <tr key={index} data-idx={index} className="cursor-pointer">
                        <td>
                            <input type="checkbox" name="checkTask"
                                   value={index} checked={checked.includes(item.id)}
                                   onChange={handleCheckbox}/>
                        </td>
                        <td data-value={item.id} onClick={handleRow}>{item.name}</td>
                    </tr>
                ))
            }
            </tbody>
        </table>
    );
}

export default ModalTasksTable
